// extracted by mini-css-extract-plugin
export default {"container":"pageloader_container__Bg9Eo"};